import { BiLogoGithub } from "react-icons/bi";
import { AiOutlineMail } from "react-icons/ai";
import { motion } from "framer-motion";

const Contact = () => {
  // Variants
  const containerVars = {
    initial: { opacity: 0 },
    animate: {
      opacity: 1,
      transition: {
        staggerChildren: 0.6,
      },
    },
  };

  const itemVars = {
    initial: { opacity: 0, x: -100 },
    animate: {
      opacity: 1,
      x: 0,
      transition: {
        duration: 0.9,
      },
    },
  };

  return (
    <section id="contact" className="contact container">
      <div className="section__heading">
        <h3 className="section__heading--sub">- Let's connect</h3>
        <h2 className="section__heading--main">Get in touch</h2>
      </div>

      <motion.div
        variants={containerVars}
        initial="initial"
        whileInView="animate"
        className="contact__list"
      >
        <motion.div variants={itemVars} className="contact__item">
          <div className="contact__logo">
            <AiOutlineMail />
          </div>
          <div className="contact__info">
            <h2 className="contact__title">Mail</h2>
            <a href="mailto:rehanshafqat2004@gmail.com" className="contact__text">
              rehanshafqat2004@gmail.com
            </a>
          </div>
        </motion.div>
        <motion.div variants={itemVars} className="contact__item">
          <div className="contact__logo">
            <BiLogoGithub />
          </div>
          <div className="contact__info">
            <h2 className="contact__title">GitHub</h2>
            <a href="https://github.com/RehanShafqat/" className="contact__text">
              RehanShafqat
            </a>
          </div>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Contact;
